/*! DO NOT EDIT: This file is auto-generated and will be overwritten. [build-fingerprint:assets:source={/app/_js/standalone/animations/index.js}] */
"use strict";
(() => {
  // _js/standalone/animations/index.js
  var SCROLL_ANIMATION_TRIGGER_CLASSNAME = "scroll-trigger", SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = "\
scroll-trigger--offscreen", SCROLL_ANIMATION_CANCEL_CLASSNAME = "scroll-trigger--cancel", onIntersection = (elements, observer) => {
    elements.forEach((element, index) => {
      if (element.isIntersecting) {
        let elementTarget = element.target;
        elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME) && (elementTarget.classList.
        remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME), elementTarget.hasAttribute("data-cascade") && elementTarget.
        setAttribute("style", `--animation-order: ${index};`)), observer.unobserve(elementTarget);
      } else
        element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME), element.target.classList.
        remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    });
  }, initializeScrollAnimationTrigger = (rootEl = document, isDesignModeEvent = !1) => {
    let animationTriggerElements = Array.from(
      rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
    );
    if (animationTriggerElements.length === 0)
      return;
    if (isDesignModeEvent) {
      animationTriggerElements.forEach((element) => {
        element.classList.add("scroll-trigger--design-mode");
      });
      return;
    }
    let observer = new IntersectionObserver(onIntersection, {
      rootMargin: "0px 0px -50px 0px"
    });
    animationTriggerElements.forEach((element) => {
      observer.observe(element);
    });
  };
  window.addEventListener("DOMContentLoaded", () => {
    initializeScrollAnimationTrigger();
  });
  var isThemeEditor = document.documentElement.classList.contains(
    "shopify-design-mode"
  );
  isThemeEditor && (document.addEventListener("shopify:section:load", (event) => {
    initializeScrollAnimationTrigger(event.target, !0);
  }), document.addEventListener("shopify:section:reorder", () => {
    initializeScrollAnimationTrigger(document, !0);
  }));
})();
